var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRacpadAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.077,
    height: 19.249,
    viewBox: "0 0 23.077 19.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "alert",
    d: "M22.654,40.875l-8.839-13.85a2.7,2.7,0,0,0-4.552,0L.424,40.875A2.7,2.7,0,0,0,2.7,45.027H20.378a2.7,2.7,0,0,0,2.276-4.152ZM11.539,42.7a1.472,1.472,0,1,1,1.472-1.472A1.472,1.472,0,0,1,11.539,42.7Zm2.04-10.227-.725,4.88a1.315,1.315,0,0,1-2.6.017L9.468,32.5a2.08,2.08,0,0,1,4.107-.664A2.142,2.142,0,0,1,13.579,32.47Z",
    transform: "translate(0 -25.778)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRacpadAlert);
export default __webpack_public_path__ + "static/media/racpad-alert.6f95537c.svg";
export { ForwardRef as ReactComponent };